import { render, staticRenderFns } from "./stakeForMining.vue?vue&type=template&id=e0bf5cec&scoped=true&"
import script from "./stakeForMining.vue?vue&type=script&lang=js&"
export * from "./stakeForMining.vue?vue&type=script&lang=js&"
import style0 from "./stakeForMining.vue?vue&type=style&index=0&id=e0bf5cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf5cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0bf5cec')) {
      api.createRecord('e0bf5cec', component.options)
    } else {
      api.reload('e0bf5cec', component.options)
    }
    module.hot.accept("./stakeForMining.vue?vue&type=template&id=e0bf5cec&scoped=true&", function () {
      api.rerender('e0bf5cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/stakeForMining.vue"
export default component.exports